import axios from 'axios'

export default {
	methods: {
		async sendFeedback() {
            this.loader.load = true

            const payload = {
                instance: this.getInstance(),
                type: this.filters[0].params.value,
                comment: this.sendMessage,
                satisfied: this.satisfied,
                feature: this.featureURL,
                feature_url: this.originURL,
                fac_user_id: this.userIdentity,
                fac_user_name: this.userName,
                fac_user_email: this.userEmail,
                fac_user_mobile: this.userMobile,
                fac_user_group: this.userGroup,
            }

            try {
                await axios({
                    method: 'POST',
                    url: 'https://services.appfacilita.com/api/v1/feedbacks',
                    data: payload,
                    headers: {
                        'client-token': process.env.VUE_APP_NPS_API_TOKEN,
                    },
                })

            } catch (error) {
                console.error(error);
            }

            this.loader.load = false
            this.filters[0].params.value = null
            this.sendMessage = ''
            this.filtersCheckbox[0].items[0].checked = false
            this.$root.$emit('modal-open-thank-feedback-modal')
            this.close()
        },

        close() {
            this.$root.$emit('modal-close-feedback-modal')
        },

        sortByHandler(checked, index) {
            const selectedIndex = this.filtersCheckbox.findIndex(filter => filter.name === 'checked-feedback')
            const sorts = this.filtersCheckbox[selectedIndex].items.map((item, i) => {
                item.checked = i === index ? checked : false
                return item
            })
            if (checked) {
                const sort = this.filtersCheckbox[selectedIndex].items[index]
                this.$set(this.filtersCheckbox[selectedIndex], 'selected', { value: sort.value })
                this.satisfied = sort.value
            } else {
                this.$set(this.filtersCheckbox[selectedIndex], 'selected', { value: '' })
            }
            this.buttonSatisfied = checked
            this.$set(this.filtersCheckbox[selectedIndex], 'items', sorts)
        }
	},
}
